import { assertError } from './asserts/assertError';
import { EType } from '../../repositories/sms/entities/PublicValidationCode/PublicSendValidationCodeRequest';
import {
  ISendValidationCodeResponse200,
  ISendValidationCodeResponse400,
} from '../../repositories/sms/v2/send-validation-code';
import { fetchSendValidationCode } from '../../repositories/sms/v2/send-validation-code/apiHelpers';
import { TThunkAction } from '../../types/redux/thunk';
import { setPhoneValidation } from '../pageState';
import {
  setPhoneConfirmationError,
  setRequestFailure,
  setRequestSubmitting,
  setRequestSuccess,
} from '../phoneValidationCode/actions';

interface IRequestPhoneValidationCodeParams {
  phone: string;
}

export function requestPhoneValidationCode(parameters: IRequestPhoneValidationCodeParams): TThunkAction<Promise<void>> {
  return async (dispatch, getState, context) => {
    const { httpApi } = context;

    const { phone } = parameters;

    dispatch(setRequestSubmitting());
    try {
      const response = await fetchSendValidationCode<ISendValidationCodeResponse200, ISendValidationCodeResponse400>({
        httpApi,
        parameters: { phone, type: EType.NewBuildingCallbackForm },
      });

      assertError(response);

      dispatch(setPhoneValidation());

      dispatch(setRequestSuccess({ secondsToRetry: response.response.secondsToRetry || 0 }));
    } catch (error) {
      if (error.errors?.phoneNumberIsInvalid) {
        dispatch(setPhoneConfirmationError({ error: error.errors.phoneNumberIsInvalid }));
      }
      if (error.errors?.tryValidationCodeLater) {
        dispatch(setPhoneValidation());
        dispatch(
          setPhoneConfirmationError({
            error: error.errors.tryValidationCodeLater,
            secondsToRetry: 0,
          }),
        );
      }

      dispatch(setRequestFailure({ secondsToRetry: 0 }));
    }
  };
}
